import * as actionTypes from './actionTypes';

const toggleDrawer = () => ({
  type: actionTypes.TOGGLE_DRAWER,
});

export {
  toggleDrawer, // eslint-disable-line import/prefer-default-export
};
